import React from "react";
import "../../style/Footer.css";
import { useLocation } from "react-router-dom";
import { FOOTER_CARDS } from "../../utils/footerUtils";

function ContactFooter({ language }) {
  const { pathname } = useLocation();

  const isSpacePage = pathname.includes("/space");

  return (
    <div
      className={`contact-footer-container ${
        isSpacePage ? "contact-footer-mb" : ""
      }`}
    >
      {FOOTER_CARDS.map((card) => (
        <ContactCard key={card.id} card={card} language={language} />
      ))}
    </div>
  );
}

function ContactCard({ card, language }) {
  const { id, path, alt, image, text } = card;
  return (
    <a key={id} className="footer-card" href={path}>
      <div className="footer-card clickable">
        <img className="footer-image" alt={alt} src={image} />
        <div className="footer-card-text body-b1 white">{text[language]}</div>
      </div>
    </a>
  );
}

export default ContactFooter;
